import src from "IMAGE";
export default { src, width: 100, height: 100, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAQElEQVR42r2PMQ4AIAgDQSHRBHE0cXXx/y8Udli9pcN1aAErIwRQV9Z9J4SyCck6w0u5tPwmbUgqHb8SrjWwMD5ALwRclyxWIwAAAABJRU5ErkJggg=="};
